'use client'

import {ReactNode} from 'react'
import s from './style.module.scss'
import {usePathname} from 'next/navigation'
import {GAMEPLAYER_ROUTE} from '@app/constants/global'

type Props = {
  children: ReactNode
  isMobile: boolean
}

export const useIsGamePage = () => {
  const path = usePathname()
  return {isGamePage: path?.includes(`${GAMEPLAYER_ROUTE}/`)}
}

const ContentWrapperClient = ({children, isMobile}: Props) => {
  return isMobile ? children : <div className={s.desktop_horizontal_scroll}>{children}</div>
}

export default ContentWrapperClient
